import { useNavigate } from "react-router-dom";
import { Row, Col, Container, Button } from 'react-bootstrap';

import './style.scss';

const SectionFive = () => {
  const navigate = useNavigate();

  return (
    <div id="sectionFive">
      <Container>
        <div className="sectionFive-text">
          <Row>
            <Col align="center">
              <h2>Interested in partnering with us? Let's do business</h2>
            </Col>
          </Row>
          <Row className="mx-auto my-4">
            <Col align="center">
              <Button
                className='business'
                onClick={() => navigate("/business")}
              >
                Learn more
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default SectionFive;
